export default __webpack_public_path__ + "static/martin_hochel-fcdb43d3d54de2ade5d11c8367e6517d.jpg";